import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataShareService {

  constructor() { }

  showSplashScreen: Subject<boolean> = new Subject<boolean>();


  private messageSource = new BehaviorSubject<Number>(0);
  currentMessage = this.messageSource.asObservable();

  changeAppMenuHeight(height: Number) {
    this.messageSource.next(height);
  }

  setSplashScreenFlag(val: boolean) {
    this.showSplashScreen.next(val);
  }

  getSplashScreenFlag(): Observable<boolean> {
    return this.showSplashScreen;
  }
}
